// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {Install_btn} from '../ui/install_btn';
import {Editor} from '../../../shared/editor/editor';
import cn from 'classnames';
import styles from './download_vpn_banner.module.less';

interface i_download_vpn_banner_props {
    title: string;
    button_text: string;
}

export const Download_vpn_banner = (props: i_download_vpn_banner_props)=>{
    const {theme} = useContext(Settings_context);
    const install_btn_cls = cn('hola_btn hola_btn--lg hola_btn--round',
        'hola_btn--txt_colored hola_btn--no_jump');
    return <div>
      <div className={cn([theme.content_center, styles.content])}>
        <h2 className={styles.header}>{props.title}</h2>
        <h4 className={styles.header}>{props.title}</h4>
        <Install_btn keep_btn_text text={props.button_text}
          app_fixed="vpn" no_redirect className={install_btn_cls}/>
      </div>
    </div>;
};

interface i_download_vpn_banner_editor_props {
    value: i_download_vpn_banner_props;
    on_change: (new_val: i_download_vpn_banner_props)=>void;
}

export const Download_vpn_banner_editor = (
{value, on_change}: i_download_vpn_banner_editor_props)=>{
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'title', label: 'Title (h1)', type: 'text'},
        {key: 'button_text', label: 'Button text', type: 'text'},
      ]}/>;
};
